(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('plagiat2017App')
        .constant('VERSION', "2.3.00")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
